import React, { FC } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";
import Card from "../../../hoc/Card";

interface Props {
  type: "input" | "description";
  matches?: number;
  classes?: any;
  textInput?: string;
  errorMessage?: string;
  onInputUpdate?: (text: string) => void;
}

const cardStyles = {
  paddingLeft: "12px",
  paddingRight: "12px",
  paddingTop: "12px",
  paddingBottom: "12px",
  height: "100%"
};

const SmartListCard: FC<Props> = props => {
  return (
    <div className={props.classes.cardContainer}>
      <Card overrideStyles={cardStyles}>
        <div style={{ position: "relative" }}>
          <textarea
            onChange={e => props.onInputUpdate(e.target.value)}
            maxLength={100}
          ></textarea>
          {props.textInput && props.textInput.length >= 100 && (
            <span className={props.classes.limitCharacterText}>
              100 characters max
            </span>
          )}
        </div>
        <div className={props.classes.footer}>
          {props.errorMessage && (
            <div className={props.classes.error}>{props.errorMessage}</div>
          )}
          <div className={props.classes.matches}>
            <div className="count">{props.matches}</div>
            <div className="text">Matches</div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default injectSheet(styleSheet)(SmartListCard);
